var _rect, _path, _mask, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryLowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 15,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#4A4A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C2 2.94772 2.44772 2.5 3 2.5H5V8.5H3C2.44772 8.5 2 8.05228 2 7.5V3.5Z",
    fill: "#FF5670"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_892_303432",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5V2.5C17.5523 2.5 18 2.94772 18 3.5V7.5C18 8.05228 17.5523 8.5 17 8.5V8.5V2.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5H16V9.5H17V8.5ZM17 2.5V1.5H16V2.5H17ZM17 3.5V7.5H19V3.5H17ZM18 8.5V2.5H16V8.5H18ZM17 7.5V9.5C18.1046 9.5 19 8.60457 19 7.5H17ZM17 3.5H19C19 2.39543 18.1046 1.5 17 1.5V3.5Z",
    fill: "#4A4A4A",
    mask: "url(#path-3-inside-1_892_303432)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLowRed);
export default __webpack_public_path__ + "static/media/batteryLowRed.8b6a1debf0b225fa607c6e98140dacd0.svg";
export { ForwardRef as ReactComponent };